<template>
  <div>
    <div v-if="file && file.length > 0" class="w-auto absolute inset-x-0 top-8">
      <div v-for="(item, index) in file" :key="index"
        class="w-full flex justify-center items-center"
      >
        <div class="w-auto h-full flex justify-center items-center gap-1">
          <div>
            <icon icon-name="pdf" size="xs" class="icon" v-if="item.mimeType === 'pdf'"/>
            <icon icon-name="doc" size="xs" class="icon" v-else-if="item.mimeType === 'doc'"/>
            <icon icon-name="xlsx" size="xs" class="icon" v-else-if="item.mimeType === 'xlsx'"/>
            <icon icon-name="csv" size="xs" class="icon" v-else-if="item.mimeType === 'csv'"/>
            <icon icon-name="ppt" size="xs" class="icon" v-else-if="item.mimeType === 'ppt'"/>
            <icon icon-name="png" size="xs" class="icon" v-else-if="item.mimeType === 'png'"/>
            <icon icon-name="jpg" size="xs" class="icon" v-else-if="item.mimeType === 'jpg'"/>
            <icon icon-name="jpg" size="xs" class="icon" v-else-if="item.mimeType === 'jpeg'"/>
          </div>

          <div class="flex justify-center gap-2">
            <p class="text-blackJet text-sm">
              {{ item.fileName && item.fileName.length > 12 ? item.fileName.slice(0, 12) + '...' : item.fileName }}
              .{{ item.mimeType }}
            </p>
            <p class="text-xs text-romanSilver mt-1">
                • {{ item.fileSize.toFixed(2) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {  },
  name: "FilesUpload",
  props: {
    file: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
  }
};
</script>

<style scoped>
</style>
